import { isRouteAccessDenied } from "@/session/route-query";
import { queryOptions } from "@tanstack/react-query";
import { getFrontDoor } from "./preview.functions";

export function frontDoorQueryOptions({ href }: { href: string }) {
  const url = new URL(href, "https://softmax.invalid");
  const version = url.searchParams.get("version");
  const resourceHref = `${url.pathname}${version ? `?${new URLSearchParams({ version })}` : ""}`;
  return queryOptions({
    queryKey: ["preview", "front-door", resourceHref],
    queryFn: ({ signal }) => getFrontDoor({ href: resourceHref, signal }),
    throwOnError: isRouteAccessDenied,
    staleTime: 60_000,
  });
}
